import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faTimes, faAddressCard } from '@fortawesome/free-solid-svg-icons';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import baseURL from '../../url';
import '../AdminCommon.css';
import './NewContact.css';

export default function NewContact({ onContactCreated }) {
    const [cargando, setCargando] = useState(false);
    const [nombre, setNombre] = useState('');
    const [telefono, setTelefono] = useState('');
    const [instagram, setInstagram] = useState('');
    const [email, setEmail] = useState('');
    const [direccion, setDireccion] = useState('');
    const [facebook, setFacebook] = useState('');
    const [modalOpen, setModalOpen] = useState(false);

    const resetForm = () => {
        setNombre('');
        setTelefono('');
        setInstagram('');
        setEmail('');
        setDireccion('');
        setFacebook('');
    };

    const toggleModal = () => {
        if (modalOpen) {
            resetForm();
        }
        setModalOpen(!modalOpen);
    };

    const crear = async (e) => {
        if (e) e.preventDefault();

        if (!nombre.trim()) {
            toast.warn('Ingresa el nombre del establecimiento o titular.');
            return;
        }

        const formData = new FormData();
        formData.append('nombre', nombre.trim());
        formData.append('telefono', telefono.trim());
        formData.append('instagram', instagram.trim());
        formData.append('email', email.trim());
        formData.append('direccion', direccion.trim());
        formData.append('facebook', facebook.trim());

        setCargando(true);
        try {
            const response = await fetch(`${baseURL}/contactoPost.php`, {
                method: 'POST',
                body: formData,
            });

            const data = await response.json();

            if (data.mensaje) {
                toast.success(data.mensaje);
                resetForm();
                setModalOpen(false);
                if (typeof onContactCreated === 'function') {
                    onContactCreated();
                } else {
                    window.location.reload();
                }
            } else if (data.error) {
                toast.error(data.error);
            }
        } catch (error) {
            console.error('Error al registrar contacto:', error);
            toast.error('Error de conexión. Por favor, inténtalo de nuevo.');
        } finally {
            setCargando(false);
        }
    };

    return (
        <div>
            <button onClick={toggleModal} className="adminBtnPrimary" title="Agregar información de contacto">
                <FontAwesomeIcon icon={faPlus} /> Agregar contacto
            </button>

            {modalOpen && (
                <div className="adminModalOverlay" onClick={toggleModal}>
                    <div className="adminModalContent modalContactoEdit" onClick={(e) => e.stopPropagation()}>
                        <div className="adminModalHeader">
                            <h3><FontAwesomeIcon icon={faAddressCard} /> Agregar Contacto</h3>
                            <button type="button" className="adminModalClose" onClick={toggleModal}>
                                <FontAwesomeIcon icon={faTimes} />
                            </button>
                        </div>

                        <form onSubmit={crear}>
                            <div className="adminModalBody">
                                <div className="formGridRow2">
                                    <div className="adminFormField">
                                        <label>Nombre del Establecimiento / Titular (Obligatorio):</label>
                                        <input
                                            type="text"
                                            placeholder="Ej: Sucursal Central, Atención Comercial..."
                                            value={nombre}
                                            onChange={(e) => setNombre(e.target.value)}
                                            required
                                            autoFocus
                                        />
                                    </div>

                                    <div className="adminFormField">
                                        <label>Teléfono / WhatsApp:</label>
                                        <input
                                            type="text"
                                            placeholder="+54 9 11 1234-5678"
                                            value={telefono}
                                            onChange={(e) => setTelefono(e.target.value)}
                                        />
                                    </div>
                                </div>

                                <div className="formGridRow2">
                                    <div className="adminFormField">
                                        <label>Correo Electrónico:</label>
                                        <input
                                            type="email"
                                            placeholder="contacto@restaurante.com"
                                            value={email}
                                            onChange={(e) => setEmail(e.target.value)}
                                        />
                                    </div>

                                    <div className="adminFormField">
                                        <label>Dirección Física:</label>
                                        <input
                                            type="text"
                                            placeholder="Av. Principal 123, Ciudad"
                                            value={direccion}
                                            onChange={(e) => setDireccion(e.target.value)}
                                        />
                                    </div>
                                </div>

                                <div className="formGridRow2">
                                    <div className="adminFormField">
                                        <label>Enlace de Instagram:</label>
                                        <input
                                            type="url"
                                            placeholder="https://instagram.com/tu-restaurante"
                                            value={instagram}
                                            onChange={(e) => setInstagram(e.target.value)}
                                        />
                                    </div>

                                    <div className="adminFormField">
                                        <label>Enlace de Facebook:</label>
                                        <input
                                            type="url"
                                            placeholder="https://facebook.com/tu-restaurante"
                                            value={facebook}
                                            onChange={(e) => setFacebook(e.target.value)}
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="adminModalFooter">
                                <button type="button" className="adminBtnSecondary" onClick={toggleModal} disabled={cargando}>
                                    Cancelar
                                </button>
                                <button type="submit" className="adminBtnPrimary" disabled={cargando}>
                                    {cargando ? 'Guardando...' : 'Guardar Contacto'}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}
        </div>
    );
}
